import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { useSelector } from 'react-redux';
import AverageUtilizationTile from './AverageUtilizationTile';
import Style from '../../../../constants/Style';
import { Space } from '../../../Map/SetFloorsModal/FloorItem';
import { Metric } from '../../../../constants/Types';
import GetMetric from '../../../../requests/Sensors/GetMetric';
import { DateRange } from '../../../../redux/dateRangeSlice';
import { getAverageFromGraphData } from '../../../TopSection';
import asNumber from '../../../AsNumber';

interface RoomUtilizationGridProps {
  spaces: Space[],
}

const RoomUtilizationGrid = ({ spaces }: RoomUtilizationGridProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => state.dateRange);
  const [utilizationValues, setUtilizationValues] = useState<(number | null)[]>([]);
  const [previousUtilizationValues, setPreviousUtilizationValues] = useState<(number | null)[]>([]);

  useEffect(() => {
    if (!spaces) return;
    const difference: number = new Date(range.end).getTime() - new Date(range.start).getTime();
    const previousStart: string = new Date(new Date(range.start).getTime() - difference)
      .toISOString();
    Promise.all(spaces.map((space: Space) => GetMetric({
      metric: Metric.UTILIZATION, range, externalId: space.ExternalId,
    }))).then((res) => setUtilizationValues(res.map(getAverageFromGraphData)));
    Promise.all(spaces.map((space: Space) => GetMetric({
      metric: Metric.UTILIZATION,
      range: { start: previousStart, end: range.start },
      externalId: space.ExternalId,
    }))).then((res) => setPreviousUtilizationValues(res.map(getAverageFromGraphData)));
  }, [range, spaces]);

  return <View style={styles.container}>
    {spaces?.length > 0 ? spaces.map((space: Space, index: number) => <AverageUtilizationTile
      name={space.Name}
      value={utilizationValues[index]}
      difference={asNumber((100 * (utilizationValues[index] - previousUtilizationValues[index]))
        / previousUtilizationValues[index])}
      key={`average_utilization_tile_${index}`}
    />) : <Text style={styles.emptyStateText}>{'No spaces available'}</Text>}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    ...Style.row,
    flexWrap: 'wrap',
  },
  emptyStateText: {
    textAlign: 'center',
    width: '100%',
    aspectRatio: 3,
    paddingTop: '15%',
  },
});

export default RoomUtilizationGrid;
